<template>
    <div id="nueva-planificacion">
        <Button
            :size="15"
            color="#28a745"
            colorText="#ffffff"
            tooltip="Agregar una nueva planificación"
            icon="icon fas fa-plus"
            round
            :width="30"
            class="mr-2"
            @click.native="openModal('modal'), resetEstado()"
            traslate
        />
    
        <ui-modal ref="modal" title="Opciones para creación de planificación" size="normal" @close="idSelected = 1, ActionSetZindexModal(false)">

            <!-- Menu -->
            <div class="d-flex justify-content-center mt-3">
                <Button
                    v-for="(item, index) in estadoBotones" :key="index"
                    :size="17"
                    :color="item.color"
                    colorText="#ffffff"
                    :tooltip="item.text"
                    :icon="item.icon"
                    :width="40"
                    round
                    class="mr-2"
                    @click.native="estadoBotonSeleccionado(item.id)"
                    traslate
                    :active="item.estado"
                    :traslateSelected="item.estado"
                />
            </div>

            <!-- Body -->
            <div class="my-4 p-3">

                <fieldset-component class="mb-3" :texto="subTitulo" bold />

                <div class="mt-3">
                    <!-- Copiar Planificación del año anterior -->
                    <div class="d-flex flex-column" v-if="idSelected == 1">
                      <p>Para copiar la planificación de años anteriores, por favor complete los siguientes espacios</p>
                      <div class="d-flex ">
                        <ui-select
                          class="w-100 ml-3"
                          has-search
                          label="Año a copiar"
                          placeholder="Seleccionar"
                          v-model="yearToCopyModelPap"
                          :options="listaAniosACopiar"
                          @change="setPapClients"
                          :keys="{ value: 'id', label: 'name' }"
                        />

                        <ui-select
                          v-if="usuarioActual.rol != 'Cliente'"
                          has-search
                          class="w-100 ml-3"
                          label="Cliente"
                          placeholder="Seleccionar"
                          v-model="clientToCopyModelPap"
                          :options="filteredPapClients"
                          :keys="{ value: 'id', label: 'name' }"
                        />

                        <ui-select
                          class="w-100 ml-3"
                          has-search
                          label="Año a planificar"
                          placeholder="Seleccionar"
                          v-model="yearToPlannifyModelPap"
                          :options="listaAnios"
                          :keys="{ value: 'id', label: 'year' }"
                        />
                      </div>
                      <div class="d-flex">
                        <div class="row mt-2"></div>
                        <div class="col-md-6">
                          <Button
                            color="#ffa500"
                            colorText="#ffffff"
                            text="Limpiar"
                            :width="130"
                            :height="40"
                            class="ml-5"
                            style="float: left"
                            @click.native="clearCopyForm"
                          />
                        </div>
                        <div class="col-md-6">
                          <Button
                            color="#dc3545"
                            text="Copiar planificación"
                            colorText="#ffffff"
                            :width="150"
                            :height="40"
                            style="float: right"
                            :inactive="!enabledCopyButtons"
                            @click.native="enabledCopyButtons ? copyFromPreviousYear() : ''"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- Copiar desde Real Embarcado del año anterior -->
                    <div class="d-flex flex-column" v-else-if="idSelected == 2">
                      <p>Para copiar la planificación del real embarcado de años anteriores, por favor complete los siguientes espacios</p>
                      <div class="d-flex ">
                        <ui-select
                          class="w-100 ml-3"
                          has-search
                          label="Año a copiar"
                          placeholder="Seleccionar"
                          v-model="yearToCopyModel"
                          :options="listaAniosACopiar"
                          @change="setApeClients"
                          :keys="{ value: 'id', label: 'name' }"
                        />
                        <ui-select
                          has-search
                          class="w-100 ml-3"
                          label="Cliente"
                          placeholder="Seleccionar"
                          v-model="clientToCopyModel"
                          :options="filteredApeClients"
                          :keys="{ value: 'id', label: 'name' }"
                          v-if="usuarioActual.rol != 'Cliente'"
                        />
                        <ui-select
                          class="w-100 ml-3"
                          has-search
                          label="Año a planificar"
                          placeholder="Seleccionar"
                          v-model="yearToPlannifyModel"
                          :options="listaAnios"
                          :keys="{ value: 'id', label: 'year' }"
                        />
                      </div>
                      <div class="d-flex">
                        <div class="row mt-2"></div>
                          <div class="col-md-6">
                            <Button
                              color="#ffa500"
                              colorText="#ffffff"
                              text="Limpiar"
                              :width="130"
                              :height="40"
                              class="ml-5"
                              style="float: left"
                              @click.native="clearCopyForm"
                            />
                          </div>
                          <div class="col-md-6">
                            <Button
                              color="#dc3545"
                              text="Copiar planificación"
                              colorText="#ffffff"
                              :width="150"
                              :height="40"
                              style="float: right"
                              :inactive="!enabledCopyButtons"
                              @click.native="enabledCopyButtons ? copyFromRealEmbarked() : ''"
                            />
                          </div>
                        </div>
                    </div>

                    <!-- Cargar Planificación desde archivo de Excel -->
                    <div v-else-if="idSelected == 3">
                        <file-upload-simple-component text="Seleccionar planificación"
                            :width="200"
                            :height="30"
                            horizontal
                            :constant="constant_path"
                        />
                    </div>

                    <!-- Agregar planificación anual manualmente -->
                    <div class="d-flex flex-column" v-else-if="idSelected == 4">

                        <div class="d-flex mt-4">
                            <ui-select class="w-100" label="Seleccionar año (*)" v-model="anioModel" hasSearch searchPlaceholder="Buscar año"
                                        :options="listaAnios" :keys="{ value: 'id' , label: 'year' }" />

                            <ui-select class="w-100 ml-3" label="Empresa (*)" v-model="empresaModel" hasSearch searchPlaceholder="Buscar Empresa"
                                        :options="listaClientes" :keys="{ value: 'id', label: 'name' }" @change="obtenerConsignatarios($event)"
                                        v-if="usuarioActual.rol != 'Cliente'"/>

                            <ui-select class="w-100 ml-3" label="Contenedor (*)" v-model="contenedorModel"  hasSearch searchPlaceholder="Buscar Contenedor"
                                        :options="lista_contenedores" :keys="{ value: 'id', label: 'name' }" @change="obtenerProductos($event)" />

                            <ui-select class="w-100 ml-3" label="Producto (*)" v-model="productoModel" hasSearch searchPlaceholder="Buscar producto"
                                        :options="lista_productos" :keys="{ value: 'id', label: 'name' }" 
                                        :disabled="lista_productos.length == 0 ? true : false"/>

                            <ui-select class="w-100 ml-3" label="Consignatario (*)" v-model="consignatarioModel" hasSearch searchPlaceholder="Buscar consignatario"
                                        :options="lista_consignatarios" :keys="{ value: 'id', label: 'name' }" 
                                        :disabled="lista_consignatarios.length == 0 ? true : false" />

                            <ui-select class="w-100 ml-3" label="Serv. Integral (*)" v-model="servicioIntegralModel" hasSearch searchPlaceholder="Buscar Serv. Integral"
                                        :options="listaServIntegral" :keys="{ value: 'id', label: 'name' }"  />

                        </div>

                         <Button v-if="isSave" text="Guardar" :size="25" color="#28a745" colorText="#ffffff" :width="100" :height="50" fullWidth :inactive="true"/>
                         <Button v-else text="Guardar" :size="25" color="#28a745" colorText="#ffffff" :width="100" :height="50" fullWidth @click.native="crearPlanificacionManual"/>

                    </div>

                </div>

            </div>

        </ui-modal>

    </div>
</template>

<script>

     // Vue
    import Vue from "vue";

    // Toast
    import VueToastify from "vue-toastify";
    Vue.use(VueToastify);

    import { mapActions, mapState } from 'vuex';

    // Keen UI
    import UiModal from "keen-ui/src/UiModal";
    import UiSelect from "keen-ui/src/UiSelect";

    import Button from '../../common/Button';
    import FileUploadSimpleComponent from '../../common/fileUploadSimpleComponent';
    import FieldsetComponent from '../../common/FieldsetComponent';
    import {copyFromPreviousYear, copyFromRealEmbarked, getConsignatariosPorCliente, getProductosPorContenedor, guardarPlanificacionAnual, importarPlantillaPlanificacionAnual } from "../../../constants/lineas";


    export default {
        props : ['pod'],

        computed : {
            ...mapState('lineas',[
              'listaAnios',
              'listaClientes',
              'listaClientesPap',
              'listaClientesApe',
              'listaServIntegral',
              'lista_contenedores',
              'yearsFilter',
              'listaAniosACopiar'
            ]),
            ...mapState(['uploadFileLoading','usuarioActual'])
        },

        components : {Button, UiModal, UiSelect, FileUploadSimpleComponent, FieldsetComponent },

        data() {
            return {
                constant_path: importarPlantillaPlanificacionAnual,

                // Input Model
                anioModel               : [],
                empresaModel            : [],
                contenedorModel         : [],
                productoModel           : [],
                consignatarioModel      : [],
                servicioIntegralModel   : [],

                yearToCopyModel: [],
                yearToCopyModelPap: [],
                clientToCopyModel: [],
                clientToCopyModelPap: [],
                yearToPlannifyModel: [],
                yearToPlannifyModelPap: [],
                filteredPapClients: [],
                filteredApeClients: [],


                subTitulo               : '',
                idSelected              : 0,
                fileUploadModel         : '',
                urlFile                 : '',
                estadoBotones           : [
                    {
                        id     : 0,
                        estado : true,
                        color  : '#ffa500',
                        text   : 'Copiar Planificación del año anterior',
                        icon   : "fas fa-undo"
                    },
                    {
                        id: 1,
                        estado : false,
                        color  : '#dc3545',
                        text   : "Copiar desde Real Embarcado del año anterior",
                        icon   : "fas fa-undo"
                    },
                    {
                        id: 2,
                        estado  : false,
                        color   : '#007bff',
                        text    : "Cargar Planificación desde archivo de Excel",
                        icon    : "fas fa-cloud-upload-alt"
                    },
                    {
                        id: 3,
                        estado  : false,
                        color   : '#28a745',
                        text    : "Agregar planificación anual manualmente",
                        icon    : "icon fas fa-plus"
                    }
                ],
                isSave                  : false,
                enabledCopyButtons: true,
                lista_consignatarios : [],
                lista_productos : []
            }
        },

        methods : {

            ...mapActions(['ActionSetZindexModal']),
            ...mapActions('lineas',['actionSetDataPlanificacionAnualTabla']),

            openModal(ref) {
                this.$refs[ref].open();
                this.ActionSetZindexModal(true);
            },

            closeModal(ref) {
                this.$refs[ref].close();
            },

            async estadoBotonSeleccionado(id){

                let data_aux = await this.estadoBotones.filter( item => {

                    if (id == item.id) {
                        item.estado = true;

                        this.subTitulo = item.text;
                        this.idSelected = id + 1;


                    } else {
                        item.estado = false;
                    }

                    return item;

                });

                this.estadoBotones = data_aux;

            },

            resetEstado(){

                let data_aux = this.estadoBotones.filter( (item, index) => {

                    item.estado = index == 0 ? true : false;
                    this.subTitulo = 'Copiar Planificación del año anterior';
                    this.idSelected = 1;

                    return item;

                });

                this.estadoBotones = data_aux;

            },

            async crearPlanificacionManual(){


              if (!this.anioModel.id) {
                return this.$vToastify.error("Seleccione año a planificar", "Error: Año a planificar");
              }

              if (
                !this.empresaModel.id && this.usuarioActual.rol === "Administrador" ||
                !this.empresaModel.id && this.usuarioActual.rol === "Super Administrador" ||
                !this.empresaModel.id && this.usuarioActual.rol === "Ejecutivo" ||
                !this.empresaModel.id && this.usuarioActual.rol === "Operador"
              ) {
                return this.$vToastify.error("Seleccione una empresa", "Error: Empresa");
              }

              if (!this.contenedorModel.id) {
                return this.$vToastify.error("Seleccione un tipo de contenedor", "Error: Tipo Contenedor");
              }

              if (!this.productoModel.id) {
                return this.$vToastify.error("Seleccione un tipo de producto", "Error: Tipo Producto");
              }

                let plans     = [];
                let data      = [];

                this.isSave = true;

                data.push({
                    "year"                : this.anioModel.id,
                    "client_id"           : this.empresaModel.id,
                    "container_id"        : this.contenedorModel.id,
                    "product_category_id" : this.productoModel.id,
                    "consignee_id"        : this.consignatarioModel.id,
                    "integral_service_id" : this.servicioIntegralModel.id,
                    "total"               : 0
                });

                plans.push({ "plans" : [{
                    type : 1,
                    data : data[0]
                }]});

                const sql = await guardarPlanificacionAnual(plans[0]);

                if (sql.code == 200) {
                    this.actionSetDataPlanificacionAnualTabla();
                    this.$vToastify.stopLoader();
                    this.$vToastify.success( sql.message, "Proceso finalizado");
                    this.closeModal('modal');
                    this.isSave = false;

                    this.anioModel              = [];
                    this.empresaModel           = [];
                    this.contenedorModel        = [];
                    this.productoModel          = [];
                    this.consignatarioModel     = [];
                    this.servicioIntegralModel  = [];

                } else {
                    this.$vToastify.stopLoader();
                    this.$vToastify.error( sql.message, "Proceso finalizado");
                    this.isSave = false;
                }

            },

            clearCopyForm(){

                this.yearToCopyModel = [];
                this.yearToCopyModelPap = [];
                this.clientToCopyModel = [];
                this.clientToCopyModelPap = [];
                this.yearToPlannifyModel = [];
                this.yearToPlannifyModelPap = [];
            },

            setPapClients() {

              this.filteredPapClients = [];

              if (this.yearToCopyModelPap.id) {

                this.filteredPapClients = this.listaClientesPap.filter(customer => customer.years.includes(this.yearToCopyModelPap.name));

              } else {

                return this.$vToastify.error("Seleccione Año a copiar", "Error: Año a copiar");

              }

            },

            setApeClients() {

              this.filteredApeClients = [];

              if (this.yearToCopyModel.id) {

                this.filteredApeClients = this.listaClientesApe.filter(customer => customer.years.includes(this.yearToCopyModel.name));

              } else {

                return this.$vToastify.error("Seleccione Año a copiar", "Error: Año a copiar");

              }

            },

            async copyFromRealEmbarked() {

              if (!this.yearToCopyModel.id) {

                return this.$vToastify.error("Seleccione Año a copiar", "Error: Año a copiar");

              }

              if (
                !this.clientToCopyModel.id && this.usuarioActual.rol === "Administrador" ||
                !this.clientToCopyModel.id && this.usuarioActual.rol === "Super Administrador" ||
                !this.clientToCopyModel.id && this.usuarioActual.rol === "Ejecutivo" ||
                !this.clientToCopyModel.id && this.usuarioActual.rol === "Operador"
              ) {

                return this.$vToastify.error("Seleccione un Cliente", "Error: Cliente");

              }

              if (!this.yearToPlannifyModel.id) {

                return this.$vToastify.error("Seleccione un Año a planificar", "Error: Año a planificar");

              }

              this.enabledCopyButtons = false;

              let form = {
                "year_to_copy": this.yearToCopyModel.id,
                "client_to_copy": this.clientToCopyModel.id,
                "year_to_planning": this.yearToPlannifyModel.id
              }

              this.$vToastify.loader("Copiando real embarcado de "+ this.yearToCopyModel.name +  "...");

              let response = await copyFromRealEmbarked(form);

              if (response.code === 200) {

                this.clearCopyForm();

                this.closeModal('modal');

                this.$vToastify.success(response.message, "Éxito");

                this.actionSetDataPlanificacionAnualTabla();

              } else if (response.code && response.errors) {

                Object.values(response.errors).forEach(errorArray => {
                  errorArray.forEach(error => {
                    this.$vToastify.error(error, "Error");
                  });
                });

              } else {

                this.$vToastify.error(response.message, "Error");
              }

              this.$vToastify.stopLoader();

              this.enabledCopyButtons = true;
            },

            async copyFromPreviousYear() {

              if (!this.yearToCopyModelPap.id) {

                return this.$vToastify.error("Seleccione Año a copiar", "Error: Año a copiar");

              }

              if (
                !this.clientToCopyModelPap.id && this.usuarioActual.rol === "Administrador" ||
                !this.clientToCopyModelPap.id && this.usuarioActual.rol === "Super Administrador" ||
                !this.clientToCopyModelPap.id && this.usuarioActual.rol === "Ejecutivo" ||
                !this.clientToCopyModelPap.id && this.usuarioActual.rol === "Operador"
              ) {

                return this.$vToastify.error("Seleccione un Cliente", "Error: Cliente");

              }
              if (!this.yearToPlannifyModelPap.id) {

                return this.$vToastify.error("Seleccione un Año a planificar", "Error: Año a planificar");

              }

              this.enabledCopyButtons = false;

              let form = {
                "year_to_copy": this.yearToCopyModelPap.id,
                "client_to_copy": this.clientToCopyModelPap.id,
                "year_to_planning": this.yearToPlannifyModelPap.id
              }

              this.$vToastify.loader("Copiando planificaciones de "+ this.yearToCopyModelPap.name +  "...");

              let response = await copyFromPreviousYear(form);

              if (response.code === 200) {

                await this.actionSetDataPlanificacionAnualTabla();

                this.clearCopyForm();
                
                this.closeModal('modal');

                this.$vToastify.success(response.message, "Éxito");

              } else if (response.code && response.errors) {

                Object.values(response.errors).forEach(errorArray => {
                  errorArray.forEach(error => {
                    this.$vToastify.error(error, "Error");
                  });
                });

              } else {

                this.$vToastify.error(response.message, "Error");
              }

              this.$vToastify.stopLoader();

              this.enabledCopyButtons = true;

            },

            async obtenerConsignatarios(e){
              
              let {code, data} = await getConsignatariosPorCliente(e.id);

              code == 200 ? this.lista_consignatarios = data : this.lista_consignatarios = [];

            },

            async obtenerProductos(e){

              let {code, data} = await getProductosPorContenedor(e.id);
              code == 200 ? this.lista_productos = data : this.lista_productos = [];

            }

        },

        mounted(){

          if(this.usuarioActual.rol == 'Cliente'){

            this.obtenerConsignatarios({id: this.usuarioActual.id_cliente, name: this.usuarioActual.client});

          }

        },

        watch : {

            uploadFileLoading : function(_new){

                !_new && this.closeModal('modal');

            }

        }


    }

</script>


<style>

    #nueva-planificacion .ui-modal--size-normal > .ui-modal__wrapper > .ui-modal__container{
        width: 85% !important;
    }

    #nueva-planificacion .ui-modal__body {
        padding: 0;
    }

</style>